// accordions
const accordionGroups = document.querySelectorAll( ".accordion-group" );

accordionGroups.forEach( ( group ) => {
  const items = group.querySelectorAll( ".accordion-item" );

  // Open the first accordion item by default
  items.forEach( ( item, i ) => {
    const content = item.querySelector( ".accordion-content" );
    if ( i === 0 ) {
      item.classList.add( "active" );
      content.style.height = content.scrollHeight + "px";
    } else {
      content.style.height = "0px";
    }

    // Add click event listener to each toggle
    item.querySelector( ".accordion-toggle" ).addEventListener( "click", function () {
      const isActive = item.classList.contains( "active" );

      // Close all items
      items.forEach( ( otherItem ) => {
        otherItem.classList.remove( "active" );
        otherItem.querySelector( ".accordion-content" ).style.height = "0px";
      } );

      // Re-open the clicked one if it was not already active
      if ( !isActive ) {
        item.classList.add( "active" );
        item.querySelector( ".accordion-content" ).style.height =
          item.querySelector( ".accordion-content" ).scrollHeight + "px";
      }
    } );
  } );
} );
